const Training = () => {
    return (
        <section className='page-section' id='formazione'>
            <div className='container' data-aos='fade-up'>
                <div className='text-center'>
                    <h2 className='section-heading text-uppercase'>Formazione</h2>
                    <h3 className='section-subheading text-muted'>
                        Da sempre attenta alla sicurezza del personale interno, l’azienda ha esteso ultimamente la propria esperienza al
                        servizio di altre aziende. Infatti, è in grado di offrire corsi formativi per operatori finalizzati, attraverso un
                        percorso teorico e pratico, alla perfetta conoscenza dei macchinari che si utilizzano nel lavoro quotidiano.
                    </h3>
                </div>
                <div className='row text-center'>
                    <div className='col-md-4'>
                        <span className='fa-stack fa-4x'>
                            <i className='fas fa-circle fa-stack-2x text-primary'></i>
                            <i className='far fa-address-card fa-stack-1x fa-inverse'></i>
                        </span>
                        <h4 className='my-3'>Attestati</h4>
                        <p className='text-muted'>
                            Superate le prove sottoposte durante i corsi, sarà rilasciato ai lavoratori un attestato cartaceo di
                            abilitazione a rilascio immediato. È prevista, inoltre, la fornitura del tesserino formato card su specifica
                            richiesta, non a rilascio immediato.
                        </p>
                    </div>
                    <div className='col-md-4'>
                        <span className='fa-stack fa-4x'>
                            <i className='fas fa-circle fa-stack-2x text-primary'></i>
                            <i className='fas fa-chalkboard-teacher fa-stack-1x fa-inverse'></i>
                        </span>
                        <h4 className='my-3'>Corsi in E-Learning</h4>
                        <p className='text-muted'>
                            Al fine di agevolare il più possibile i nostri clienti, offriamo corsi a distanza fruibili attraverso l’uso di
                            internet per la parte teorica.
                            <br />A completamento sarà effettuata la prova pratica dai nostri formatori sulle attrezzature messe a
                            disposizione dalla nostra azienda.
                        </p>
                    </div>
                    <div className='col-md-4'>
                        <span className='fa-stack fa-4x'>
                            <i className='fas fa-circle fa-stack-2x text-primary'></i>
                            <i className='far fa-lightbulb fa-stack-1x fa-inverse'></i>
                        </span>
                        <h4 className='my-3'>L’offerta formativa</h4>
                        <p className='text-muted'>
                            Il Decreto Legislativo 81/2008 impone a tutte le aziende la formazione dei lavoratori. In particolare, offriamo
                            la formazione rivolta ad alcune categorie di lavoratori specifici: RLS (Responsabile dei Lavoratori per la
                            Sicurezza), RSPP (Responsabile del Servizio di Prevenzione e Protezione), preposti, dirigenti, addetti
                            antincendio, addetti al primo soccorso, HACCP e privacy.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Training;
